import type { Element as XmlEl } from "@xmpp/xml"

/** `Element.attrs` is `any`; this makes the string return type true, not asserted. */
export const attr = (
  el: XmlEl | undefined,
  name: string
): string | undefined => {
  const value = el?.attrs[name]
  return typeof value === "string" ? value : undefined
}

/**
 * Move an element from one stanza to another, for envelope data the nested
 * message needs but does not carry.
 *
 * REPLACES what the target had: `getChild` returns the first match, so an
 * appended element would lose to it.
 */
export const hoist = (
  source: XmlEl,
  target: XmlEl,
  tag: string,
  ns: string
): void => {
  const element = source.getChild(tag, ns)
  if (!element) return

  const existing = target.getChild(tag, ns)
  if (existing) target.remove(existing)

  source.remove(element)
  target.cnode(element)
}
